module.exports = __webpack_public_path__ + "static/media/icon_payment_black.66688ba6.svg";